var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"pager",attrs:{"total":_vm.total,"show-elevator":""},on:{"on-change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }